import HardcodedSalesDemoPath from '../data/hardcodedSalesDemoPath';

const demoToDashboardLinkMapper = {
  [HardcodedSalesDemoPath.Ads]: 'https://bitmovin.com/dashboard/analytics/data',
  [HardcodedSalesDemoPath.StreamLab]:
    'https://bitmovin.com/dashboard/player/stream-testing?orgId=6af25605-1bd1-458d-8de9-1189f9ccf6df&3rdParty=false&apiKey=5cd462f7-73c1-424e-82d0-1a9bfabcf310' // tslint:disable-line:max-line-length
};

class LaunchDashboardSalesDemosRegistry {
  private constructor() {}

  public static getLaunchDashboardLink(salesDemoPath: string): string {
    return demoToDashboardLinkMapper[salesDemoPath] || null;
  }
}

export default LaunchDashboardSalesDemosRegistry;
